import React from 'react';
import 'assets/css/spinner.scss';
import { Image } from 'react-bootstrap';
import ReactLogo from 'assets/img/icono_happ_fav.svg'

const SubmitLoader = ({ show }) => {
    return (
        <div className={`submit-preloader bg-soft flex-column justify-content-center align-items-center ${show ? "" : "show"}`}>
            <Image className="loader-element animate_animated animate_jackInTheBox" src={ReactLogo} height={40} />
        </div>
    )
}

export default SubmitLoader;